import { useEffect, useRef, useState } from "react"
import { LayoutGrid, ExternalLink } from "lucide-react"

import { Button } from "@/components/ui/button"
import { api } from "@/services/api"

interface AppEntry {
  label: string
  url: string
}

/**
 * App-Switcher (Etappe 6 nxtools): Grid-Icon im Header, Eintraege kommen
 * rechte-gefiltert vom Backend (GET /apps). Kein Sidebar-Menuepunkt —
 * externe Anwendungen (z. B. nxtools) sind nur hier verlinkt.
 */
export function AppSwitcher() {
  const [apps, setApps] = useState<AppEntry[]>([])
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    api
      .getApps()
      .then(setApps)
      .catch(() => setApps([]))
  }, [])

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener("mousedown", onClick)
    return () => document.removeEventListener("mousedown", onClick)
  }, [])

  if (apps.length === 0) return null

  return (
    <div className="relative" ref={ref}>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setOpen((o) => !o)}
        title="Anwendungen"
      >
        <LayoutGrid className="h-5 w-5" />
        <span className="sr-only">Anwendungen</span>
      </Button>
      {open && (
        <div className="absolute right-0 top-full z-50 mt-1 w-56 rounded-md border bg-card p-1 shadow-md">
          {apps.map((a) => (
            <a
              key={a.url}
              href={a.url}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 rounded px-3 py-2 text-sm hover:bg-secondary"
            >
              <ExternalLink className="h-4 w-4 text-muted-foreground" />
              {a.label}
            </a>
          ))}
        </div>
      )}
    </div>
  )
}
